import { DependencyList, useEffect } from "react";
import {
  eventListener,
  IActionBarUpdate,
  TOPICS,
} from "@origin-digital/event-dispatcher";

interface PropertySelectorChangeHandlers {
  onEnabledChange?: (value: boolean) => void;
  onShowAllPropertiesChange?: (value: boolean) => void;
  onShowServiceSelectorChange?: (value: boolean) => void;
}

/**
 * Provide handlers for when changes are made to the display of the property selector.
 *
 * Listens for action bar update events and calls the appropriate handlers.
 */
export const useActionBarPropertySelectorUpdates = (
  {
    onEnabledChange,
    onShowAllPropertiesChange,
    onShowServiceSelectorChange,
  }: PropertySelectorChangeHandlers,
  deps?: DependencyList
) => {
  useEffect(() => {
    return eventListener.addListener(
      TOPICS.ACTION_BAR_UPDATE,
      (topic: IActionBarUpdate) => {
        if (topic.payload.propertySelector) {
          if (
            onEnabledChange &&
            topic.payload.propertySelector.enabled !== undefined
          ) {
            onEnabledChange(topic.payload.propertySelector.enabled);
          }
          if (
            onShowAllPropertiesChange &&
            topic.payload.propertySelector.showAllProperties !== undefined
          ) {
            onShowAllPropertiesChange(
              topic.payload.propertySelector.showAllProperties
            );
          }
          if (
            onShowServiceSelectorChange &&
            topic.payload.propertySelector.showServiceSelector !== undefined
          ) {
            onShowServiceSelectorChange(
              topic.payload.propertySelector.showServiceSelector
            );
          }
        }
      }
    );
  }, deps);
};
